import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  const linkCls =
    "overline text-white/60 hover:text-white transition-colors px-1";

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 bg-[#1A1A1A] border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => navigate("/")}
          className="flex items-center gap-2.5 group"
        >
          <img src="/rtb-logo.png?v=2" alt="Right To Bear" className="h-12 w-auto object-contain" />
          <span className="flex flex-col leading-none text-left">
            <span className="font-display text-lg tracking-tight">RIGHT TO BEAR</span>
            <span className="text-[9px] uppercase tracking-[0.28em] text-[hsl(var(--rtb-copper))] font-medium mt-0.5">
              Pure Peace of Mind
            </span>
          </span>
        </button>

        <nav className="flex items-center gap-5 sm:gap-7">
          {user ? (
            <>
              <button
                data-testid="nav-dashboard"
                onClick={() => navigate("/dashboard")}
                className={linkCls}
                style={{ color: location.pathname === "/dashboard" ? "#fff" : undefined }}
              >
                Schedule
              </button>
              {user.role === "admin" && (
                <button
                  data-testid="nav-admin"
                  onClick={() => navigate("/admin")}
                  className={linkCls}
                  style={{ color: location.pathname === "/admin" ? "#fff" : undefined }}
                >
                  Admin
                </button>
              )}
              <span className="hidden sm:inline overline text-white/40">
                {user.name?.split(" ")[0] || "Rep"}
              </span>
              <button
                data-testid="nav-logout"
                onClick={onLogout}
                className="flex items-center gap-1.5 overline text-white/60 hover:text-[hsl(var(--primary))] transition-colors"
              >
                <LogOut className="w-4 h-4" /> Out
              </button>
            </>
          ) : (
            <>
              <button data-testid="nav-login" onClick={() => navigate("/login")} className={linkCls}>
                Log In
              </button>
              <button
                data-testid="nav-register"
                onClick={() => navigate("/register")}
                className="overline bg-[hsl(var(--primary))] text-white px-4 py-2 hard-shadow-hover"
              >
                Join The Team
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
